/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const ClaimsSchemaFieldDateValue: core.serialization.ObjectSchema<
    serializers.ClaimsSchemaFieldDateValue.Raw,
    Truvity.ClaimsSchemaFieldDateValue
> = core.serialization.object({
    isArray: core.serialization.property('is_array', core.serialization.boolean().optional()),
    jsonLdIri: core.serialization.property('json_ld_iri', core.serialization.string().optional()),
    jsonLdType: core.serialization.property('json_ld_type', core.serialization.string().optional()),
    name: core.serialization.string(),
    notEmpty: core.serialization.property('not_empty', core.serialization.boolean().optional()),
    title: core.serialization.string().optional(),
});

export declare namespace ClaimsSchemaFieldDateValue {
    export interface Raw {
        is_array?: boolean | null;
        json_ld_iri?: string | null;
        json_ld_type?: string | null;
        name: string;
        not_empty?: boolean | null;
        title?: string | null;
    }
}
